import { FC } from "react";
import { FormInput } from "shared/ui";
import type { CreateRaffleForm } from "../model/useCreateRaffle";
import { LabeledInput } from "./LabeledInput";

import styles from "./CreateWheelRaffleForm.module.css";

interface Props {
  form: CreateRaffleForm;
}

// Пул и число победителей: пул делится между ними поровну.
export const AmountFields: FC<Props> = ({ form }) => {
  const { values, errors, setValue, isSubmitting, realBalance } = form;

  return (
    <div className={styles.row}>
      <LabeledInput
        label="Prize pool, USDT"
        hint={`Debited right away. Available: ${realBalance.toFixed(2)}`}
      >
        <FormInput
          inputMode="decimal"
          placeholder="100.00"
          value={values.prizePool}
          error={errors.prizePool}
          onValueChange={(value) => setValue("prizePool", value)}
          disabled={isSubmitting}
          autoFocus
        />
      </LabeledInput>
      <LabeledInput label="Winners" hint="The pool is split equally.">
        <FormInput
          inputMode="numeric"
          placeholder="3"
          value={values.winnersCount}
          error={errors.winnersCount}
          onValueChange={(value) => setValue("winnersCount", value)}
          disabled={isSubmitting}
        />
      </LabeledInput>
    </div>
  );
};
